import type { StaticInventoryItem } from '@flexpath/core/src/types/staticInventory-types.d.ts';
import { conditionLabel, conditionClass, formatPrice, formatMiles } from './format-utils.ts';

declare global {
  interface Window { openPrequalModal?: () => void }
}

const BODY_STYLE_ICONS: Record<string, string> = {
  suv: 'images/suv.svg',
  pickup: 'images/pickup.svg',
  sedan: 'images/sedan.svg',
  van: 'images/minivan.svg',
  minivan: 'images/minivan.svg',
  coupe: 'images/convertible.svg',
  convertible: 'images/convertible.svg',
};

export function carPlaceholderHtml(fpBodyStyle: string | null, extraClass?: string, hidden?: boolean): string {
  const icon = fpBodyStyle ? BODY_STYLE_ICONS[fpBodyStyle] : undefined;
  const cls = 'car-placeholder' + (extraClass ? ' ' + extraClass : '');
  const style = hidden ? ' style="display:none;"' : '';
  return icon
    ? `<div class="${cls}"${style}><img src="${icon}" alt="${fpBodyStyle}"></div>`
    : `<div class="${cls}"${style}><img src="images/sedan.svg"></div>`;
}

function vdpUrl(v: StaticInventoryItem): string {
  return 'vehicle-detail.html?stock=' + encodeURIComponent(v.stock);
}

export function buildVehicleCard(v: StaticInventoryItem): string {
  const label = conditionLabel(v.condition);
  const cls = conditionClass(v.condition);
  const milesStr = formatMiles(v.miles, v.condition);
  const img = v.images && v.images.length ? v.images[0] : '';
  const imgCount = v.images ? v.images.length : 0;
  const url = vdpUrl(v);
  const colorLbl = v.colorExtFancy || v.colorExt || '';

  const imgHtml = img
    ? `<img src="${img}" alt="${v.year} ${v.make} ${v.model}" loading="lazy" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"`
        + ` onerror="this.style.display='none';this.parentElement.querySelector('.img-fallback').style.display='flex'">`
        + carPlaceholderHtml(v.fpBodyStyle, 'img-fallback', true)
    : carPlaceholderHtml(v.fpBodyStyle);

  return `<div class="vehicle-card">`
    + `<div class="vehicle-image">`
    +   imgHtml
    +   `<span class="vehicle-badge ${cls}">${label}</span>`
    +   (imgCount > 1 ? `<span class="vehicle-photo-count">📷 ${imgCount} Photos</span>` : '')
    + `</div>`
    + `<div class="vehicle-info">`
    +   `<div class="vehicle-year-make">${v.year} · ${v.make}</div>`
    +   `<div class="vehicle-name">${v.model} ${v.trim}</div>`
    +   `<div class="vehicle-specs">`
    +     `<div class="vehicle-spec">${v.drivetrain}</div>`
    +     (milesStr ? `<div class="vehicle-spec">${milesStr}</div>` : '')
    +     (colorLbl ? `<div class="vehicle-spec">🎨 ${colorLbl}</div>` : '')
    +   `</div>`
    +   `<div class="vehicle-pricing">`
    +   `<div class="vehicle-price">${formatPrice(v.priceMap ?? 0)}</div>`
    +   `<div class="fpdxp fpdxp-from-VRP fpdxp-flow-SI fpdxp-cta-SIB fpdxp-vin-${v.vin} fpdxp-stock-${v.stock}"></div>`
    +   `</div>`
    +   `<div class="vehicle-actions">`
    +     `<a href="${url}" class="btn btn-primary">View Details</a>`
    +     `<a href="prequalify.html" class="btn btn-dark fpdxp fpdxp-retain fpdxp-from-VRP fpdxp-flow-GPQ fpdxp-cta-CB fpdxp-vin-${v.vin} fpdxp-stock-${v.stock}">Pre-Qualify by Phone Number</a>`
    +   `</div>`
    + `</div>`
    + `</div>`;
}

export function initPrequalTriggers(container?: ParentNode): void {
  (container || document).querySelectorAll('[data-modal="prequal"]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      window.openPrequalModal?.();
    });
  });
}
